import React, { useRef } from 'react';
import { StyledAlert, StyledCustomDialog, StyledIconButton, StyledInner, StyledLayoutContainer, StyledOverlay } from '../index.styles.js';
import {} from '../index.js';
export const DialogCustom = ({ children, padding = true, open, triggerButton, variant, dialogAriaProps, onCloseButtonAriaLabel, onCloseButtonClick, onClose, 'data-testid': dataTestId, className, role, hasCloseButton }) => {
    const ref = useRef(null);
    // TODO: Remove handleClose and replace it with the onClose prop once onCloseButtonClick has been removed
    const handleClose = () => {
        if (onCloseButtonClick) {
            onCloseButtonClick();
        }
        if (onClose) {
            onClose();
        }
    };
    return (React.createElement(React.Fragment, null,
        triggerButton,
        open && (React.createElement(React.Fragment, null,
            React.createElement(StyledOverlay, { onClick: handleClose }),
            React.createElement(StyledCustomDialog, { ref: ref, "aria-describedby": dialogAriaProps?.ariaDescribedBy, "aria-labelledby": dialogAriaProps?.ariaLabelledBy, variant: variant, hasPadding: padding, "data-testid": dataTestId, className: className, role: role || 'dialog' }, variant === 'alert' ? (React.createElement(StyledAlert, { hasPadding: padding }, children)) : (React.createElement(StyledLayoutContainer, null,
                hasCloseButton && (React.createElement(StyledIconButton, { "aria-label": onCloseButtonAriaLabel, variant: "tertiary", icon: "cancel", onClick: handleClose, size: "sm" })),
                React.createElement(StyledInner, { hasPadding: padding, variant: variant }, children))))))));
};
//# sourceMappingURL=custom.js.map